import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { LoggingService } from '@services/logging.service';
import { FilterService } from '@services/filter.service';
import { TreeNode } from 'primeng/api';
import * as Constants from '@shared/_constants';
import { FilterUtilService } from '../shared/filter-util.service';
import { SearchStrategyService } from '@services/search-strategy.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
  selector: 'app-filter-bvdindependence-indicator',
  templateUrl: './filter-bvdindependence-indicator.component.html',
  styleUrls: ['./filter-bvdindependence-indicator.component.css'],
  providers: [SearchStrategyService],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class FilterBVDIndependenceIndicatorComponent implements OnInit, OnDestroy {
  @Input() filter: any;
  @Input() bvdIndependence: TreeNode[] = [];
  @Input() readOnly = false;

  formDirty = false;
  filterBefore = '';

  private destroy$ = new Subject();

  constructor(private logger: LoggingService, private filterService: FilterService, private filterUtilService: FilterUtilService) {}

  ngOnInit() {
    this.loadInitialData();
  }
  loadInitialData() {
    this.logger.info(this.constructor.name, Constants.LoggerMessages.LOGGER_NGONINIT, Constants.LoggerMessages.LOGGER_START);
    this.filterUtilService.spinnerRS.next(true);

    this.filterService
      .getBvdIndependence$()
      .pipe(takeUntil(this.destroy$))
      .subscribe((_bvdIndependence) => {
        this.bvdIndependence = _bvdIndependence;
        this.filterUtilService.spinnerRS.next(false);
        this.filterBefore = JSON.stringify(this.filter);
      });
  }

  public sortSelection(selection: TreeNode[]): void {
    return this.filterUtilService.sortSelection(selection, true);
  }

  ngOnDestroy() {
    this.destroy$.next(true);
  }
}
